export const accordionThemeToTailwindClasses = (theme: any) => {
    const type = theme.type || "default";

    if (type === "default") {
        return ["border-b", "border-gray-200", "rounded-lg"];
    }

    if (type === "ghost") {
        return ["border-b", "border-gray-200"];
    }

    if (type === "detached") {
        return ["border-b", "border-gray-200", "flex", "flex-col", "gap-4", "!bg-transparent"];
    }

    if (type === "small") {
        return ["border-b", "border-gray-200"];
    }

    return ["border-b", "border-gray-200"];
};
